export const theme = {
  namespaced: true,
  state: {
    dark: false,
  },
  mutations: {
    SET_DARK(state, value) {
      state.dark = value;
      document.documentElement.classList.toggle('dark', value);
      localStorage.setItem('theme', value ? 'dark' : 'light');
    },
  },
  actions: {
    toggle({ state, commit }) {
      commit('SET_DARK', !state.dark);
    },
  },
};
